export enum LightType {
    DIRECTIONAL = 1,
    POINT,
    SPOT,
    HEMISPHERIC
}
